import { useEffect, useState } from 'react';
import { digestMessage } from '../utils/crypto';

const useAuthChallenge = (stringToHash: string) => {
  const [cryptographicHash, setCryptographicHash] = useState<string>();
  useEffect(() => {
    const getCryptographicHash = async () => {
      setCryptographicHash(await digestMessage(stringToHash));
    };
    getCryptographicHash();
  }, [stringToHash]);

  return { challengeCode: cryptographicHash };
};

export { useAuthChallenge };
